export default __webpack_public_path__ + "static/media/instagram.c83e628e.svg";